export default __webpack_public_path__ + "../staticImages/country-ch.svg";